// extracted by mini-css-extract-plugin
module.exports = {"ds-icon":"Icon_ds-icon__kRGux","large":"Icon_large__wqjSZ","podcast-logo":"Icon_podcast-logo__roRyj"};